import { useEffect, useState } from 'react'
import {
  landingFetchCampaignAchievements,
  type LandingCampaignAchievements,
} from '@/lib/landing-achievements'

type AchievementState = {
  campaignId: number | null
  data: LandingCampaignAchievements | null
  error: string | null
}

const pending = new Map<string, Promise<LandingCampaignAchievements>>()

export function useLandingCampaignAchievements(
  campaignId: number,
  refreshSignal = 0,
  donorId = 0
) {
  const [state, setState] = useState<AchievementState>({
    campaignId: null,
    data: null,
    error: null,
  })

  useEffect(() => {
    let cancelled = false

    const key = `${donorId}:${campaignId}:${refreshSignal}`
    let request = pending.get(key)
    if (!request) {
      request = landingFetchCampaignAchievements(campaignId)
      pending.set(key, request)
      const clear = () => {
        if (pending.get(key) === request) pending.delete(key)
      }
      void request.then(clear, clear)
    }
    void request
      .then((data) => {
        if (!cancelled) setState({ campaignId, data, error: null })
      })
      .catch(() => {
        if (!cancelled) {
          setState({
            campaignId,
            data: null,
            error: 'Não foi possível carregar suas conquistas agora.',
          })
        }
      })

    return () => {
      cancelled = true
    }
  }, [campaignId, refreshSignal, donorId])

  if (state.campaignId !== campaignId) {
    return { data: null, isLoading: true, error: null }
  }

  return { data: state.data, isLoading: false, error: state.error }
}
